<abp-page [title]="'AbpIdentity::Users' | abpLocalization" [toolbar]="data">
  <div id="identity-users-wrapper">
    <app-filters-card
      *ngIf="userFiltersConfig"
      [config]="userFiltersConfig"
      [(filterValues)]="filters"
      (apply)="onApplyFilters()"
      (clearAll)="clearFilters()"
    >
    </app-filters-card>
    <div class="card">
      <div class="card-body">
        <div class="header-actions">
          <div class="search-wrap">
            <i class="fa fa-magnifying-glass search-icon" aria-hidden="true"></i>
            <input
              type="search"
              class="form-control search-input"
              [placeholder]="'AbpUi::Search' | abpLocalization"
              [(ngModel)]="list.filter"
              (keyup.enter)="list.get()"
            />
          </div>
        </div>
        <abp-extensible-table
          [data]="data.items"
          [recordsTotal]="data.totalCount"
          [list]="list"
        ></abp-extensible-table>
      </div>
    </div>
  </div>
</abp-page>

<abp-modal [(visible)]="isModalVisible" [busy]="modalBusy" (disappear)="form = null">
  <ng-template #abpHeader>
    <h3>{{ (selected?.id ? 'AbpIdentity::Edit' : 'AbpIdentity::NewUser') | abpLocalization }}</h3>
  </ng-template>

  <ng-template #abpBody>
    <form *ngIf="form" [formGroup]="form" id="userForm" (ngSubmit)="save()" validateOnSubmit>
      <ul id="user-nav-tabs" ngbNav #nav="ngbNav" class="nav-tabs">
        <li id="user-informations" ngbNavItem>
          <a ngbNavLink>{{ 'AbpIdentity::UserInformations' | abpLocalization }}</a>
          <ng-template ngbNavContent
            ><abp-extensible-form class="custom-form-group" [selectedRecord]="selected"></abp-extensible-form>

            <div class="custom-form-group mt-2">
              <label for="userUnit" class="required-field-asteriks">
                {{ '::OrganizationUnit' | abpLocalization }}
              </label>
              <app-organization-unit-selector
                id="userUnit"
                formControlName="userUnit"
                [isDisabled]="!canManageOrganizationUnit"
              ></app-organization-unit-selector>
            </div>
          </ng-template>
        </li>
        <li id="user-roles" ngbNavItem *ngIf="canManageRoles">
          <a ngbNavLink>{{ 'AbpIdentity::Roles' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <div
              *ngFor="let roleGroup of roleGroups; let i = index; trackBy: trackByFn"
              class="form-check mb-3"
            >
              <input
                type="checkbox"
                class="form-check-input"
                [attr.id]="'roles-' + i"
                [formControl]="roleGroup.controls[roles[i].name]"
              />
              <label class="form-check-label" [attr.for]="'roles-' + i">{{ roles[i].name }}</label>
            </div></ng-template
          >
        </li>
        <!-- <li id="user-organization-units" ngbNavItem>
          <a ngbNavLink>{{ 'AbpIdentity::OrganizationUnits' | abpLocalization }}</a>
          <ng-template ngbNavContent>
            <abp-tree
              *ngIf="organization.nodes?.length; else noDataMessage"
              [checkStrictly]="true"
              [checkable]="true"
              [nodes]="organization.nodes"
              [isNodeSelected]="organization.selectFn"
              [(checkedKeys)]="organization.checkedKeys"
              [(expandedKeys)]="organization.expandedKeys"
            ></abp-tree>

            <ng-template #noDataMessage>
              <p class="text-muted">
                {{ 'AbpIdentity::NoOrganizationUnits' | abpLocalization }}
              </p>
            </ng-template>
          </ng-template>
        </li> -->
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-2 fade-in-top"></div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <app-custom-button
      variant="outline"
      size="md"
      [modalClose]="{ ref: this, prop: 'isModalVisible' }"
      [confirmClose]="true"
      [formRef]="form"
    >
      {{ 'AbpIdentity::Cancel' | abpLocalization }}
    </app-custom-button>

    <app-custom-button variant="primary" size="md" type="submit" (btnClick)="save()" [disabled]="modalBusy">
      {{ 'AbpIdentity::Save' | abpLocalization }}
    </app-custom-button>
  </ng-template>
</abp-modal>

<abp-permission-management
  *abpReplaceableTemplate="{
    inputs: {
      providerName: { value: 'U' },
      providerKey: { value: providerKey },
      hideBadges: { value: true },
      visible: { value: visiblePermissions, twoWay: true },
    },
    outputs: { visibleChange: onVisiblePermissionChange },
    componentKey: 'PermissionManagement.PermissionManagementComponent',
  }"
  [(visible)]="visiblePermissions"
  [providerKey]="providerKey"
  [hideBadges]="true"
  providerName="U"
  [entityDisplayName]="entityDisplayName"
>
</abp-permission-management>

<abp-claim-modal [(visible)]="visibleClaims" [subject]="claimSubject"></abp-claim-modal>

<abp-modal [(visible)]="isSetPasswordModalVisible" [busy]="modalBusy">
  <ng-template #abpHeader>
    <h3>{{ 'AbpIdentity::SetPassword' | abpLocalization }}</h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="setPasswordForm" (ngSubmit)="setPassword()" validateOnSubmit>
      <div class="mt-2 fade-in-top">
        <div class="mb-3 custom-form-group">
          <label class="form-label" for="new-password">{{
            'AbpIdentity::Password' | abpLocalization
          }}</label>
          <div class="input-group">
            <div class="col-10 p-0">
              <input
                type="text"
                id="new-password"
                class="form-control"
                formControlName="newPassword"
                autofocus
              />
            </div>

            <app-custom-button
              variant="secondary"
              size="md"
              icon="fa fa-refresh"
              (btnClick)="generatePassword()"
            ></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <app-custom-button
      variant="outline"
      size="md"
      [modalClose]="{ ref: this, prop: 'isSetPasswordModalVisible' }"
      [confirmClose]="true"
      [formRef]="setPasswordForm"
    >
      {{ 'AbpIdentity::Cancel' | abpLocalization }}
    </app-custom-button>

    <app-custom-button
      variant="primary"
      size="md"
      icon="fa fa-check"
      [disabled]="setPasswordForm?.invalid || modalBusy"
      (btnClick)="setPassword()"
    >
      {{ 'AbpIdentity::Save' | abpLocalization }}
    </app-custom-button>
  </ng-template>
</abp-modal>

<abp-modal [(visible)]="isLockModalVisible" [busy]="modalBusy">
  <ng-template #abpHeader>
    <h3>{{ 'AbpIdentity::Lock' | abpLocalization }} - {{ selected.userName }}</h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="lockForm" (ngSubmit)="lock()" validateOnSubmit>
      <div class="mt-2 fade-in-top">
        <div class="mb-3" [formGroup]="lockForm">
          <abp-extensible-date-time-picker
            [prop]="dateTimePickerProps"
          ></abp-extensible-date-time-picker>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <app-custom-button
      variant="outline"
      size="md"
      [modalClose]="{ ref: this, prop: 'isLockModalVisible' }"
      [confirmClose]="true"
      [formRef]="lockForm"
    >
      {{ 'AbpIdentity::Cancel' | abpLocalization }}
    </app-custom-button>

    <app-custom-button
      variant="primary"
      size="md"
      icon="fa fa-check"
      [disabled]="lockForm?.invalid || modalBusy"
      (btnClick)="lock()"
    >
      {{ 'AbpIdentity::Save' | abpLocalization }}
    </app-custom-button>
  </ng-template>
</abp-modal>

<abp-modal [(visible)]="twoFactor.isModalVisible" [busy]="modalBusy">
  <ng-template #abpHeader>
    <h3>{{ 'AbpIdentity::TwoFactor' | abpLocalization }} - {{ selected.userName }}</h3>
  </ng-template>

  <ng-template #abpBody>
    <div class="mt-2 fade-in-top">
      <div class="form-check mb-2">
        <input
          type="checkbox"
          class="form-check-input"
          id="two-factor-enabled"
          [(ngModel)]="twoFactor.checkboxValue"
        />
        <label class="form-check-label" for="two-factor-enabled">{{
          'AbpIdentity::DisplayName:TwoFactorEnabled' | abpLocalization
        }}</label>
      </div>
    </div>
  </ng-template>

  <ng-template #abpFooter>
    <app-custom-button
      variant="outline"
      size="md"
      [modalClose]="{ ref: twoFactor, prop: 'isModalVisible' }"
      [confirmClose]="true"
      [skipFormCheck]="true"
    >
      {{ 'AbpIdentity::Cancel' | abpLocalization }}
    </app-custom-button>

    <app-custom-button
      variant="primary"
      size="md"
      icon="fa fa-check"
      [disabled]="modalBusy"
      (btnClick)="setTwoFactor()"
    >
      {{ 'AbpIdentity::Save' | abpLocalization }}
    </app-custom-button>
  </ng-template>
</abp-modal>

<abp-modal [(visible)]="visibleSessions">
  <ng-template #abpHeader>
    <h3>Sessions</h3>
  </ng-template>
  <ng-template #abpBody> </ng-template>

  <ng-template #abpFooter> </ng-template>
</abp-modal>
